const pageKey = 'GENERAL.SERIAL_NUMBER_MODAL';

export const SERIAL_NUMBER_TITLE = `${pageKey}.TITLE`;
export const SERIAL_NUMBER_DESCRIPTION = `${pageKey}.DESCRIPTION`;
